import type { ClientModule } from "../types";

/**
 * AmazonConnectApp lifecycle. The instance is created by connection.ts during init and
 * registered into the gateway afterwards, so `create` is never called for this module.
 */
export const appModule: ClientModule = {
  id: "app",
  label: "App Lifecycle",
  pkg: "@amazon-connect/app",
  clientExport: "AmazonConnectApp",
  kind: "lifecycle",
  create: () => {
    throw new Error(
      "appModule instance is supplied by connection.ts, not constructed here",
    );
  },
  events: [
    { name: "onStart", off: "offStart" },
    { name: "onStop", off: "offStop" },
    // Inherited from AmazonConnectProviderBase — provider-level connection errors, not
    // discoverable from AmazonConnectApp's own .d.ts alone.
    { name: "onError", off: "offError" },
  ],
  requests: [],
};
